/**
 * SOAR Search Main — tab switching for /search results
 */
(function () {
  class SoarSearchMain extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-soar-search-tab]');
      this.panels = this.querySelectorAll('[data-soar-search-panel]');
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.soarSearchTab));
      });
    }

    activate(key) {
      this.tabs.forEach((t) => {
        t.setAttribute('aria-selected', String(t.dataset.soarSearchTab === key));
      });
      this.panels.forEach((p) => {
        p.classList.toggle('is-active', p.dataset.soarSearchPanel === key);
      });
    }
  }

  if (!customElements.get('soar-search-main')) {
    customElements.define('soar-search-main', SoarSearchMain);
  }
})();
